<template>
  <p>tpl-Home</p>
</template>

<script>
export default {
  name: 'TplHome',
}
</script>
